export abstract class RecoveryCoordinator<TContext> {
  private recoveryPromise: Promise<void> | null = null

  recoverAndThen<T>(context: TContext, operation: () => Promise<T>): Promise<T> {
    this.recoveryPromise ??= this.recover(context).finally(() => (this.recoveryPromise = null))

    return this.recoveryPromise.then(operation)
  }

  protected abstract recover(context: TContext): Promise<void>
}
